import { TagAssignmentStatus } from "@/services/tagAssignment/tagAssignment.api.types";

export class TagAssignmentRun {
  constructor(
    public readonly id: string,
    public readonly workspaceId: string,
    public readonly startDate: Date,
    public readonly endDate: Date,
    public readonly status: TagAssignmentStatus,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
    public readonly tagIds: string[],
  ) {}
}
